<script setup lang="ts">
import UserAvatar from '@/components/UserAvatar.vue'
import { useCurrentClient } from '@/composables/useCurrentClient'
import ClientSelector from '@/layouts/components/ClientSelector.vue'
import { STORAGE_KEY } from '@/store/designer-store'
import { STORAGE_KEY as STORAGE_KEY_TEST } from '@/utils/designer-preview-test-data'
import { clearAllFilters } from '@/utils/filterStorage'
import { useCookie } from 'nuxt/app'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()

const handleLogout = () => {
  const { setClient, clearClient } = useCurrentClient()
  clearClient()
  setClient(null)

  // Очищаем все фильтры
  clearAllFilters()

  const preservePrefix = 'balanceFilter_'
  const preserveKeys = new Set([STORAGE_KEY, STORAGE_KEY_TEST, 'support_tickets', 'support_active_admin'])

  const keys = [...Array(localStorage.length)].map((_, i) => localStorage.key(i))
  keys.forEach((key) => {
    if (key && !key.startsWith(preservePrefix) && !preserveKeys.has(key)) {
      localStorage.removeItem(key)
    }
  })

  // for (let i = 0; i < localStorage.length; i++) {
  //   const key = localStorage.key(i)
  //   if (key && !key.startsWith(preservePrefix)) {
  //     localStorage.removeItem(key)
  //   }
  // }

  const token = useCookie('access_token')
  token.value = null

  router.push('/login')
}

const userName = ref('Гость')
const userLastName = ref('')
const userRole = ref('Без роли')
const userId = ref<number | null>(null)

const isMenuOpen = ref(false)
function openSupport() {
  isMenuOpen.value = false
  router.push('/support')
}

// Закрываем меню при изменении маршрута
watch(() => route.path, () => {
  isMenuOpen.value = false
})

onMounted(() => {
  const name = localStorage.getItem('user_name')
  const lastName = localStorage.getItem('user_last_name')
  const role = localStorage.getItem('role_visible_name')
  const id = localStorage.getItem('user_id')

  if (name) userName.value = name
  if (lastName) userLastName.value = lastName
  if (role) userRole.value = role
  if (id) userId.value = Number(id)
})

</script>

<template>
  <VBadge dot location="bottom right" offset-x="3" offset-y="3" bordered color="success">
    <div class="cursor-pointer">
      <UserAvatar
        :name="userName"
        :last-name="userLastName"
        size="40"
        rounded="circle"
        :font-size="18"
      />

      <VMenu
        v-model="isMenuOpen"
        activator="parent"
        width="230"
        location="bottom end"
        offset="14px"
        :close-on-content-click="false"
      >
        <VList>
          <VListItem>
            <template #prepend>
              <VListItemAction start>
                <VBadge dot location="bottom right" offset-x="3" offset-y="3" color="success">
                  <UserAvatar
                    :name="userName"
                    :last-name="userLastName"
                    size="40"
                    rounded="circle"
                    :font-size="18"
                  />
                </VBadge>
              </VListItemAction>
            </template>

            <VListItemTitle class="font-weight-semibold">{{ userName }}</VListItemTitle>
            <VListItemSubtitle>{{ userRole }}</VListItemSubtitle>
          </VListItem>

          <!-- Селектор организаций для мобильных устройств -->
          <VListItem class="d-sm-none px-4 py-2">
            <div class="w-100">
              <div class="text-caption text-medium-emphasis mb-2">Организация</div>
              <ClientSelector />
            </div>
          </VListItem>

          <VDivider class="my-2" />

          <VListItem :to="{ path: '/personal' }">
            <template #prepend><VIcon class="me-2" icon="tabler-user-circle" size="22" /></template>
            <VListItemTitle>Профиль</VListItemTitle>
          </VListItem>

          <VListItem :to="{ path: '/subscription' }">
            <template #prepend><VIcon class="me-2" icon="tabler-credit-card" size="22" /></template>
            <VListItemTitle>Подписка</VListItemTitle>
          </VListItem>

          <VListItem :to="{ path: '/account/users' }">
            <template #prepend><VIcon class="me-2" icon="tabler-building" size="22" /></template>
            <VListItemTitle>Организация</VListItemTitle>
          </VListItem>

          <VListItem :to="{ path: '/shops' }">
            <template #prepend><VIcon class="me-2" icon="tabler-building-store" size="22" /></template>
            <VListItemTitle>Магазины</VListItemTitle>
          </VListItem>

          <VListItem :to="{ path: '/offer' }">
            <template #prepend><VIcon class="me-2" icon="tabler-file-text" size="22" /></template>
            <VListItemTitle>Публичная оферта</VListItemTitle>
          </VListItem>

          <VListItem @click="openSupport">
            <template #prepend>
              <VIcon class="me-2" icon="tabler-headset" size="22" />
            </template>
            <VListItemTitle>Поддержка</VListItemTitle>
          </VListItem>


          <VDivider class="my-2" />

          <!-- Выход -->
          <VListItem @click="handleLogout">
            <template #prepend><VIcon class="me-2" icon="tabler-logout" size="22" /></template>
            <VListItemTitle>Выход</VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
    </div>
  </VBadge>
</template>
